function isAcronymToken(word) {
    const core = word.replace(/[^A-Za-z0-9/]/g, "");
    if (!core) {
        return false;
    }
    if (/^[A-Z0-9]{2,}$/.test(core)) {
        return true;
    }
    return /^[A-Z]{2,}\/[A-Z]{2,}$/.test(core);
}

function titleCaseToken(word, isFirst) {
    if (!word) {
        return word;
    }
    if (isAcronymToken(word)) {
        return word;
    }
    const lower = word.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
}

/**
 * Title Case for static and API-derived labels (e.g. "Last Generated on:", "Preferred Language").
 * Preserves a trailing colon and tokens like CIN, DOB, IP/ED.
 */
export function toTitleCaseLabel(text) {
    const raw = String(text ?? "").trim();
    if (!raw) {
        return "";
    }

    const trailingColon = raw.endsWith(":");
    const body = trailingColon ? raw.slice(0, -1).trim() : raw;
    const normalized = body.replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();
    const words = normalized.split(" ");
    const formatted = words.map((word, i) => titleCaseToken(word, i === 0)).join(" ");

    return trailingColon ? `${formatted}:` : formatted;
}
